import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  padding: '3.5rem 1rem 0 1rem',
  flexGrow: 1,
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '1rem',
  justifyContent: 'flex-start',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '1rem',
  padding: '0rem 0.5rem',
}));

export const AlignMobileButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  position: 'fixed',
  right: '1rem',
  bottom: '3.2rem',
}));
